/**
 * Created by Ninghai on 2017/12/20.
 */
import {expireTime} from './constant'

const store = window.localStorage

/**
 * 设置缓存
 * @param id
 * @param content
 * @param start
 * @param end
 */
export const setStore = (id, content, start, end) => {
  if (!id) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  start = start || new Date().getTime()
  let name = end ? (id + '-' + start + '-' + end + '-time') : (id + '-' + start + '-time')
  store.setItem(name, new Date().getTime())
  name = end ? (id + '-' + start + '-' + end + '-data') : (id + '-' + start + '-data')
  store.setItem(name, content)
}

/**
 * 读取本地缓存
 * @param id
 * @param start
 * @param end
 * @returns {boolean}
 */
export const getStore = (id, start, end) => {
  if (!id) return
  let name = (end ? (id + '-' + start + '-' + end + '-time') : (id + '-' + start + '-time'))
  let timeStep = new Date() - new Date(parseInt(store.getItem(name)))
  if (timeStep < expireTime) {
    name = end ? (id + '-' + start + '-' + end + '-data') : (id + '-' + start + '-data')
    return JSON.parse(store.getItem(name))
  }
  return false
}

export const clearStore = () => {
  store.clear()
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js